import { CoreFilters } from '@/components/filters/core-filters';

export class CyclesPcFilter extends CoreFilters {
  $filters;
  $list;
  listItem = '.events-item';
  $forShow;
  $loadMore;
  $hideAll;
  $empty;
  $allControl;
  showItems = 4;
  showItemsStep = 4;
  specializations = [];
  point = false;
  online = false;

  constructor() {
    super();
    this.init();
  }

  init() {
    this.$filters = $('.cycles-filters');

    if (!this.$filters || this.$filters.length === 0) return;

    this.$list = $('.cycles-list');
    this.$loadMore = $('.pc-cycle-load-more');
    this.$hideAll = $('.pc-cycle-hide-all');
    this.$empty = $('.pc-cycle-empty');
    this.$allControl = $('.pc-cycles-filter-all-control');

    this.initLoadMore();
    this.initAllListeners();

    this.filterData();
  }

  initLoadMore() {
    this.$loadMore.on('click', () => {
      this.showItems += this.showItemsStep;
      this.showFiltered(this.$forShow, this.showItems);
      this.checkLoadMore(
        this.$forShow,
        this.$loadMore,
        this.$hideAll,
        this.$empty,
        this.showItems,
        this.showItemsStep
      );
    });

    this.$hideAll.on('click', () => {
      this.showItems = this.showItemsStep;
      this.showFiltered(this.$forShow, this.showItems);
      this.checkLoadMore(
        this.$forShow,
        this.$loadMore,
        this.$hideAll,
        this.$empty,
        this.showItems,
        this.showItemsStep
      );
    });
  }

  initAllListeners() {
    this.$allControl.on('change', (e) => {
      const $t = $(e.currentTarget);

      if ($t.is('.pc-cycles-filter-specializations')) {
        if ($t.prop('checked')) {
          this.specializations = $t.data('specializations');
          if (this.specializations) {
            this.specializations = this.specializations.split(',');
          } else {
            this.specializations = [];
          }
        } else {
          this.specializations = [];
        }
      }

      if ($t.is('.pc-cycles-filter-points')) {
        this.point = $t.prop('checked');
      }

      if ($t.is('.pc-cycles-filter-online')) {
        this.online = $t.prop('checked');
      }

      this.filterData();
    });
  }

  filterData() {
    const $items = this.$list.find(this.listItem);
    $items.addClass('filter-hide').removeClass('filter-for-show');

    $items.each((i, el) => {
      const $t = $(el);
      let toShow = true;
      const filters = {
        specializations: false,
        point: false,
        online: false,
      };

      if (this.specializations.length > 0) {
        let specializations = $t.data('specializations');
        if (specializations) specializations = specializations.split(',');

        filters.specializations = specializations.some(
          (r) => this.specializations.indexOf(r) >= 0
        );
      } else {
        filters.specializations = true;
      }

      if (this.point) {
        filters.point = $t.data('point');
      } else {
        filters.point = true;
      }

      if (this.online) {
        filters.online = $t.data('online');
      } else {
        filters.online = true;
      }

      if (!filters.specializations || !filters.online || !filters.point) {
        toShow = false;
      }

      if (toShow) $t.addClass('filter-for-show');
    });

    this.$forShow = this.$list.find(this.listItem + '.filter-for-show');

    this.showFiltered(this.$forShow, this.showItems);
    this.checkLoadMore(
      this.$forShow,
      this.$loadMore,
      this.$hideAll,
      this.$empty,
      this.showItems,
      this.showItemsStep
    );
  }
}
